import { FGNumberInput, FGSelectInput, FGListen } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import {
  DogWorkbookApi,
  TransientWorkbookApi,
  TransientWorkbookGridDto,
} from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl } from "../../../../../hooks";
import { useReferential } from "../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../locales";

export interface IWorkbookDialogProps {
  dogId: number;
  initialWorkbooks: TransientWorkbookGridDto[];
  onSaved: (data: TransientWorkbookGridDto) => void;
}

export const WorkbookDialog: React.FunctionComponent<IWorkbookDialogProps> = ({
  dogId,
  onSaved,
  initialWorkbooks,
}) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const api = useApiService(TransientWorkbookApi);
  const dogApi = useApiService(DogWorkbookApi);
  const [counterExists, setCounterExists] = React.useState<boolean>(false);
  const [identifierExists, setIdentifierExists] = React.useState<boolean>(
    false
  );
  const [saving, setSaving] = React.useState<boolean>(false);

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      counter: Yup.number().required(t(ETLCodes.Required)),
      workbookTypeId: Yup.number().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  const [workbooks, wloading] = useReferential(
    (a) => a.getWorkbookTypes(currentLanguage.languageId, dogId),
    false,
    []
  );

  const removedWorkbookIds = React.useMemo(
    () => initialWorkbooks.map((e) => +e.workbookTypeId),
    [initialWorkbooks]
  );

  React.useEffect(() => {
    console.log("workbooks:", initialWorkbooks);
    console.log("removed:", removedWorkbookIds);
  }, [initialWorkbooks, removedWorkbookIds]);

  const saveItem = React.useCallback(
    async (data: TransientWorkbookGridDto) => {
      setSaving(true);
      await api
        .getWorkbookDescription(data.workbookTypeId, currentLanguage.languageId)
        .then((result) => (data.workbookType = result));
      onSaved(data);
      setSaving(false);
    },
    [api, currentLanguage.languageId, onSaved]
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={new TransientWorkbookGridDto()}
      editMode={true}
      loading={false}
      validationSchema={FormSchema}
      minLabelWidth={175}
      saving={saving}
      enableDirtyCheck={false}
    >
      <FGListen
        field="workbookTypeId"
        onChanged={async (value, formik) => {
          const info = await dogApi.getWorkbookInformation(value, dogId, true);
          console.log(info);
          if (info !== null) {
            info.counter !== null
              ? setCounterExists(true)
              : setCounterExists(false);
            info.identifier > 0
              ? setIdentifierExists(true)
              : setIdentifierExists(false);
          }
          formik.setFieldValue(
            "identifier",
            info.identifier === 0 ? null : info.identifier
          );
          formik.setFieldValue(
            "counter",
            info.counter === 0 ? 1 : info.counter
          );
        }}
      />
      <FGSelectInput
        name="workbookTypeId"
        items={workbooks?.filter((e) => !removedWorkbookIds.includes(+e.value))}
        loading={wloading}
        label={t(ETLCodes.WorkbookType)}
      />
      {identifierExists && (
        <FGNumberInput name="identifier" label={t(ETLCodes.Number)} readonly />
      )}
      {counterExists && (
        <FGNumberInput label={t(ETLCodes.Counter)} name="counter" min={0} />
      )}
    </SmallFormGenerator>
  );
};
